module.exports = __webpack_public_path__ + "./assets/img/step4.94b37efe.svg";